<template>
  <div>
    <div class="quiz-change" @click="$emit('prev')">Change phone</div>
    <div class="quiz-form__inner">
      <div class="quiz-input" :class="{'has-error': codeError}">
        <label for="code">One-time code</label>
        <input v-model="code" id="code" type="text" placeholder="Enter code" @input="codeError = false">
        <div v-if="codeError" class="quiz-input-error">Verification code is invalid or expired.</div>
      </div>
      <div class="quiz-resend">
        Didn’t receive a code?
        <template v-if="timer">
          Request a new one in {{ timer }} sec
        </template>
        <span v-else @click="resendCode()">Resend</span>
      </div>
      <button
        class="quiz-btn"
        type="button"
        :disabled="code.length < 6"
        @click="checkCode()"
      >
        Finish
      </button>
    </div>
  </div>
</template>

<script>
import * as Sentry from '@sentry/browser'

export default {
  emits: ['prev', 'next', 'resend'],
  props: {
    timer: {
      type: Number,
      default: 0
    },
    uuid: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      apiUrl: import.meta.env.VITE_API_URL,
      code: '',
      phoneVerified: false,
      codeError: false
    }
  },
  methods: {
    async checkCode() {
      this.codeError = false
      if (this.phoneVerified) {
        this.$emit('next')
        return
      }
      try {
        const response = await fetch(`${this.apiUrl}/leads-center/partner/web-forms/${this.uuid}/sessions/${this.token}/phone/verify`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            web_form_uuid: this.uuid,
            web_form_session_token: this.token,
            verification_code: this.code
          })
        })
        if (response.ok) {
          this.phoneVerified = true
          this.$emit('next')
        } else {
          this.codeError = true
          const error = new Error()
          error.name = `[StepCode.vue] checkCode ${response?.status}`
          error.status = response?.status
          const text = await response.text()
          error.message = text
          throw error
        }
      } catch (error) {
        let msg = {}
        try {
          msg = JSON.parse(error?.message)
        } catch (parseError) {
          msg = { raw: error?.message }
        }
        if (msg?.status?.client_code || msg?.status?.message) error.message = `Client code ${msg?.status?.client_code}: ${msg?.status?.message}`
        else if (msg.message) error.message = msg.message
        Sentry.captureException(error, {
          extra: {
            web_form_uuid: this.uuid,
            web_form_session_token: this.token,
            verification_code: this.code,
            response: msg
          }
        })
      }
    },
    resendCode() {
      this.codeError = false
      this.$emit('resend')
    }
  }
}
</script>